const translations = {
  en: require('./en.json'),
  fr: require('./fr.json'),
};

module.exports = translations;
